export default [
    {
        question: "Patient ID",
        answer: ""
    },
    {
        question: "Current Challenges",
        answer: ""
    },
    {
        question: "Body/Location Info",
        answer: ""
    },
    {
        question: "Magic Wand",
        answer: ""
    },
    {
        question: "My Color",
        answer: ""
    },
    {
        question: "Support Network",
        answer: ""
    },
    {
        question: "Most Important Thing",
        answer: ""
    },
    {
        question: "Willing To Make Necessary Lifestyle Changes",
        answer: ""
    }
]
